import { Loader2 } from 'lucide-react'

export const LoadingOverlay = ({
  isVisible,
  message,
}: {
  isVisible: boolean
  message: string
}) => {
  if (!isVisible) return null

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
      <div className='bg-white p-6 rounded-lg shadow-lg flex flex-col items-center space-y-4'>
        <Loader2 className='w-8 h-8 animate-spin text-dark-blue' />
        <p className='text-lg font-medium text-dark-blue'>{message}</p>
      </div>
    </div>
  )
}
